import { browsingDomainStore } from '../../store';
export const getFetchedShowtimeById = (id) => {
    return browsingDomainStore.data.showtimesById[id];
};
